// eslint-disable-next-line no-shadow
export enum EOrigemSolicitacaoPin {
  NAO_INFORMADO,
  MOTORISTA_PRECADASTRO,
  MOTORISTA_ALTERA_SENHA,
  MOTORISTA_ESQUECI_MINHA_SENHA,
  MOTORISTA_TMOVPAY_PAGAMENTO_BOLETO,
  MOTORISTA_TMOVPAY_RECARGA_CELULAR,
  MOTORISTA_TMOVPAY_TRANSFERENCIA_ENTRE_CONTAS,
  MOTORISTA_TMOVPAY_TRANSFERENCIA_TED,
  FROTISTA_TMOVPAY_PAGAMENTO_BOLETO,
  FROTISTA_TMOVPAY_TRANSFERENCIA_ENTRE_CONTAS,
  FROTISTA_TMOVPAY_TRANSFERENCIA_TED,
  TMOVPAY_ALTERAR_SENHA_CONTA_CARTAO,
  TMOVPAY_ATENDIMENTO_SAC,
  FROTISTA_TMOVPAY_ONBOARDING,
  MOTORISTA_TMOVPAY_REGARGA_AUTOMATICA_TAG,
  MOTORISTA_TMOVPAY_REGARGA_AVULSA_TAG,
  MOTORISTA_TMOVPAY_REGARGA_PREPAGO_TAG,
}
